import { cn } from '@nexelem/utils';
import React from 'react';

type CircularProgressProps = {
  size?: number;
  className?: string;
};

const THICKNESS = 3.6;
const VIEWBOX_SIZE = 44;

export const CircularProgress: React.FC<CircularProgressProps> = ({ size = 100, className }) => {
  const radius = (VIEWBOX_SIZE - THICKNESS) / 2;

  return (
    <div
      className={cn('inline-block animate-spin-progress', className)}
      role="status"
      style={{ width: size, height: size }}
    >
      <svg
        className="h-full w-full"
        viewBox={`${VIEWBOX_SIZE / 2} ${VIEWBOX_SIZE / 2} ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      >
        <circle
          className="animate-circular-dash text-text-status-navy"
          cx={VIEWBOX_SIZE}
          cy={VIEWBOX_SIZE}
          fill="none"
          r={radius}
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={THICKNESS}
        />
      </svg>
    </div>
  );
};
